import { createContext, useContext, useMemo, useState } from "react";

const FloatingMicAssistantContext = createContext(null);

export const FloatingMicAssistantProvider = ({ children }) => {
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [isVoiceModeOpen, setIsVoiceModeOpen] = useState(false);

  // Chat drawer and voice overlay are mutually exclusive surfaces over the
  // same conversation state; opening one closes the other.
  const value = useMemo(
    () => ({
      isChatOpen,
      openChat: () => {
        setIsVoiceModeOpen(false);
        setIsChatOpen(true);
      },
      closeChat: () => setIsChatOpen(false),
      isVoiceModeOpen,
      openVoiceMode: () => {
        setIsChatOpen(false);
        setIsVoiceModeOpen(true);
      },
      closeVoiceMode: () => setIsVoiceModeOpen(false),
    }),
    [isChatOpen, isVoiceModeOpen],
  );

  return (
    <FloatingMicAssistantContext.Provider value={value}>
      {children}
    </FloatingMicAssistantContext.Provider>
  );
};

export const useFloatingMicAssistant = () => {
  const context = useContext(FloatingMicAssistantContext);

  if (!context) {
    throw new Error(
      "useFloatingMicAssistant must be used within FloatingMicAssistantProvider",
    );
  }

  return context;
};
